<script context="module" lang="ts">
	import WYSIWYG from './../components/inputs/WYSIWYG.svelte';
	import type { SectionConfig } from '$lib/util/pagebuilder';
	import { gql } from 'graphql-request';
	import Media from '$lib/components/media/Media.svelte';
	import Section from '$lib/components/layout/Section.svelte';
	import DirectusLink from '$lib/components/navigation/DirectusLink.svelte';
	import Button from '$lib/components/util/Button.svelte';

	export const config: SectionConfig = {
		collection: 'section_black_bar',
		availableFor: ['pages', 'special-pages', 'posts'],
		query: gql`
        internal_name
        items {
			section_black_bar_item_id {
				translations {
					languages_code {
						code
					}
					title
				}
				media {
					...Media
				}
			}
        }
    `
	};

	type Props = {
		items: {
			section_black_bar_item_id: {
				title: string;
				media: any;
			};
		}[];
	};
</script>

<script lang="ts">
	export let data: Props; // the components gets all data via this prop (additionally each top level prop is directly provided to the component)
</script>

<Section gapType="margin" type="full">
	<div class="wrapper">
		<div class="black-bar">
			{#each data.items as { section_black_bar_item_id: item }}
				<div class="container">
					<div class="icon-wrapper">
						<Media {...item.media} fit="cover" transform="s" />
					</div>
					<div class="title">
						{item.title}
					</div>
				</div>
			{/each}
		</div>
	</div>
</Section>

<style lang="scss">
	.black-bar {
		background: color(black);
		display: grid;
		grid-template-columns: repeat(4, minmax(0, 1fr));
		padding: v(content-padding-sm) v(content-padding-5xl);
		width: 100%;
		align-items: start;
		@include media(tablet) {
			padding: v(content-padding-sm);
		}
	}
	.container {
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		width: auto;
		justify-content: center;
		align-items: center;
	}
	.icon-wrapper {
		width: 36px;
		height: 36px;
		display: flex;
	}

	.title {
		@include font(h5);
		color: color(yellow);
		text-transform: uppercase;
		margin-top: v(content-gap-xs);
		text-align: center;
	}

	@include media(tablet) {
		.black-bar {
			grid-template-columns: repeat(2, minmax(0, 200px));
			gap: v(content-gap-xl);
			width: auto;
		}
	}
	.wrapper {
		display: flex;
		justify-content: center;
		align-items: center;
		background: color(black);
	}
</style>
